export const FETCH_SEARCH_SUGGESTIONS = 'FETCH_SEARCH_SUGGESTIONS';
export const FETCH_SEARCH_SUGGESTIONS_SUCCESS = 'FETCH_SEARCH_SUGGESTIONS_SUCCESS';
export const FETCH_SEARCH_SUGGESTIONS_FAILED = 'FETCH_SEARCH_SUGGESTIONS_FAILED';
export const CLEAR_SEARCH_SUGGESTIONS = 'CLEAR_SEARCH_SUGGESTIONS';
export const FETCH_SEARCH_REDIRECT = 'FETCH_SEARCH_REDIRECT';
export const FETCH_SEARCH_REDIRECT_SUCCESS = 'FETCH_SEARCH_REDIRECT_SUCCESS';
export const FETCH_SEARCH_REDIRECT_FAIL = 'FETCH_SEARCH_REDIRECT_FAIL';
export const SET_QUERY = 'SET_QUERY';

export const MINIMUM_SEARCH_QUERY_LENGTH = 1;

export interface SuggestionResponse {
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
    title?: string;
    url_key?: string;
    highlight?: string | null;
    productCount?: number;
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
}
export interface SearchSuggestionCategoryResponse extends SuggestionResponse {}

export interface SearchSuggestionBrandResponse extends SuggestionResponse {}

export interface SearchSuggestionProductResponse extends SuggestionResponse {}

export interface SearchSuggestionStaticPageResponse extends SuggestionResponse {}

export interface SearchSuggestionResponse {
    data?: {
        Categories?: SearchSuggestionCategoryResponse[];
        Brands?: SearchSuggestionBrandResponse[];
        Products?: SearchSuggestionProductResponse[];
        StaticPages?: SearchSuggestionStaticPageResponse[];
    };
}
export interface SearchRedirectsResponse {
    data?: {
        Categories?: SearchSuggestionCategoryResponse[];
        Brands?: SearchSuggestionBrandResponse[];
        Products?: SearchSuggestionProductResponse[];
        StaticPages?: SearchSuggestionStaticPageResponse[];
    };
}

export interface SearchSuggestionBucketSelection {
    title: string;
    key: string;
    url: string;
}

export interface SearchSuggestionBucket {
    title: string;
    urlKey: string;
    highlight: string;
    productCount: number;
}

export interface SearchSuggestBucket {
    titleKey: string;
    suggestionKey: string;
    items: any;
}

export interface Suggestions {
    categories: SearchSuggestionBucket[];
    brands: SearchSuggestionBucket[];
    products: SearchSuggestionBucket[];
    staticPages: SearchSuggestionBucket[];
}

export interface SearchSuggestionState {
    isFetching: boolean;
    didInvalidate: boolean;
    query: string;
    suggestion: Suggestions;
    error?: any;
    searchRedirect: Suggestions;
}

export interface FetchSearchSuggestionsAction {
    type: typeof FETCH_SEARCH_SUGGESTIONS;
}

export interface ClearSearchSuggestionsAction {
    type: typeof CLEAR_SEARCH_SUGGESTIONS;
    payload: { exemptQuery?: boolean };
}

export interface FetchSearchSuggestionsSuccessAction {
    type: typeof FETCH_SEARCH_SUGGESTIONS_SUCCESS;
    payload: SearchSuggestionResponse;
}

export interface FetchSearchSuggestionsFailedAction {
    type: typeof FETCH_SEARCH_SUGGESTIONS_FAILED;
    payload: Error;
}

export interface FetchSearchRedirectsAction {
    type: typeof FETCH_SEARCH_REDIRECT;
}

export interface FetchSearchRedirectSuccessAction {
    type: typeof FETCH_SEARCH_REDIRECT_SUCCESS;
    payload: SearchRedirectsResponse;
}
export interface FetchSearchRedirectFailedAction {
    type: typeof FETCH_SEARCH_REDIRECT_FAIL;
    payload: Error;
}

export interface SetQueryAction {
    type: typeof SET_QUERY;
    payload: { query: string };
}

export type SearchSuggestionActionTypes =
    | FetchSearchSuggestionsAction
    | FetchSearchSuggestionsSuccessAction
    | FetchSearchSuggestionsFailedAction
    | ClearSearchSuggestionsAction
    | FetchSearchRedirectsAction
    | FetchSearchRedirectSuccessAction
    | FetchSearchRedirectFailedAction
    | SetQueryAction;
